const TiposContaBancaria = {
   contaCorrente: { id: 1, descricao: "Conta Corrente (C/C)" },
   poupanca: { id: 2, descricao: "Poupança" },
   conjunta: { id: 3, descricao: "Conjunta" },
}

export default TiposContaBancaria;